import React from 'react';
import {
  PieChart, Pie, Cell, Tooltip, ResponsiveContainer
} from 'recharts';
import { formatNumber } from '../../utils/chartDataUtils';
import styles from '../../styles/Team.module.css';

const QualityScoreChart = ({ data }) => {
  const chartData = data;

  if (!chartData || chartData.length === 0) {
    return (
      <div className={styles.chartPlaceholder}>
        <div className={styles.emptyState}>
          <div className={styles.emptyStateIcon}>⭐</div>
          <h3>No Quality Data Available</h3>
          <p>Content quality data will appear here once you have posts in the selected time period.</p>
        </div>
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <defs>
          <filter id="pieShadow" x="-50%" y="-50%" width="200%" height="200%">
            <feDropShadow dx="0" dy="4" stdDeviation="8" floodColor="#000000" floodOpacity="0.3"/>
          </filter>
        </defs>
        <Pie
          data={chartData}
          cx="50%"
          cy="50%"
          labelLine={false}
          label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
          outerRadius={80}
          fill="#8884d8"
          dataKey="value"
          filter="url(#pieShadow)"
        >
          {chartData.map((entry, index) => (
            <Cell 
              key={`cell-${index}`} 
              fill={entry.color}
              stroke="#1f2937"
              strokeWidth={2}
            />
          ))}
        </Pie>
        <Tooltip 
          contentStyle={{
            backgroundColor: '#1f2937',
            border: '1px solid #374151',
            borderRadius: '12px',
            color: '#f9fafb',
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.3)',
            backdropFilter: 'blur(10px)'
          }}
          formatter={(value, name) => [formatNumber(value), name]}
          labelStyle={{ color: '#6366f1', fontWeight: 'bold' }}
        />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default QualityScoreChart; 